'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var Repo = require('ipfs-repo');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var repo = _ref.repo;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _refsLocal = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          result,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 3;
              _iterator = _asyncIterator(repo.blocks.query({
                keysOnly: true,
                signal: options.signal
              }));

            case 5:
              _context.next = 7;
              return _awaitAsyncGenerator(_iterator.next());

            case 7:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 11;
              return _awaitAsyncGenerator(_step.value);

            case 11:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 19;
                break;
              }

              result = _value;
              _context.next = 16;
              return dsKeyToRef(result.key);

            case 16:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 19:
              _context.next = 25;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 25:
              _context.prev = 25;
              _context.prev = 26;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 30;
                break;
              }

              _context.next = 30;
              return _awaitAsyncGenerator(_iterator.return());

            case 30:
              _context.prev = 30;

              if (!_didIteratorError) {
                _context.next = 33;
                break;
              }

              throw _iteratorError;

            case 33:
              return _context.finish(30);

            case 34:
              return _context.finish(25);

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 21, 25, 35], [26,, 30, 34]]);
    }));

    function refsLocal() {
      return _refsLocal.apply(this, arguments);
    }

    return refsLocal;
  }());
};

function dsKeyToRef(key) {
  try {
    return {
      ref: Repo.utils.blockstore.keyToCid(key).toString()
    };
  } catch (err) {
    return {
      err: "Could not convert block with key '".concat(key, "' to CID: ").concat(err.message)
    };
  }
}